'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiUpload = function TiUpload(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm35 26.7c0-0.2 0-0.4-0.1-0.6l-3.3-10c-0.2-0.6-0.9-1.1-1.6-1.1h-6.7v3.3h5.5l2.8 8.4h-23.2l2.8-8.4h5.5v-3.3h-6.7c-0.7 0-1.4 0.5-1.6 1.1l-3.3 10c-0.1 0.2-0.1 0.4-0.1 0.6 0 0 0 8.3 0 8.3 0 0.9 0.7 1.7 1.7 1.7h26.6c1 0 1.7-0.8 1.7-1.7 0 0 0-8.3 0-8.3z m-8.3-13.5c0.4 0 0.8-0.2 1.1-0.5 0.7-0.6 0.7-1.7 0-2.4l-7.8-7.8-7.8 7.8c-0.7 0.7-0.7 1.8 0 2.4 0.3 0.3 0.7 0.5 1.1 0.5s0.9-0.2 1.2-0.5l3.8-3.8v11.1c0 0.9 0.8 1.7 1.7 1.7s1.7-0.8 1.7-1.7v-11.1l3.8 3.8c0.3 0.3 0.7 0.5 1.2 0.5z' })
        )
    );
};

exports.default = TiUpload;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/upload.js
// module id = 2236
// module chunks = 0